// src/App.tsx
import React from "react";
import SuSuActionsPanel from "./components/SuSuActionsPanel";
import HealthCheckPanel from "./components/HealthCheckPanel";
import { ContributeV2Panel } from "./dev/ContributeV2Panel";
import ContributeV2VerifyPanel from "./dev/ContributeV2VerifyPanel";

export default function App() {
  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: 16 }}>
      <h2>WeAre-SU-SU (Testnet)</h2>
      <div style={{ color: "#666", marginBottom: 16 }}>
        Actions Panel (RAW_WEB3_ONLY) + Health Check + ContributeV2 (Sim/Send/Verify)
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 16 }}>
        <SuSuActionsPanel />
        <HealthCheckPanel />

        {/* Dev tooling panels */}
        <ContributeV2Panel />
        <ContributeV2VerifyPanel />
      </div>
    </div>
  );
}
